// extracted by mini-css-extract-plugin
export default {"menu-wrapper":"Menu_menu-wrapper__3k1-4","icon":"Menu_icon__+rU51"};